import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Users } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/daily-brief`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export const BriefRecipients = () => {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState('');

  useEffect(() => {
    axios.get(`${API}/recipients`, auth()).then(r => setRows(r.data.recipients)).catch(() => setRows(null));
  }, []);

  if (!rows) return null;

  const update = async (r, body) => {
    setBusy(r.id);
    try {
      const res = await axios.put(`${API}/recipients/${r.id}`, body, auth());
      setRows(rs => rs.map(x => (x.id === r.id ? { ...x, enabled: res.data.enabled, hour: res.data.hour } : x)));
      toast.success(`${r.full_name}: brief ${res.data.enabled ? `on · ${res.data.hour}:00 AM` : 'off'}`);
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not update'); }
    setBusy('');
  };

  return (
    <div className="w-full border-t border-slate-200/70 pt-3 mt-1" data-testid="brief-recipients">
      <div className="flex items-center gap-2 text-xs font-bold text-slate-500 uppercase tracking-wider mb-2"><Users className="w-3.5 h-3.5" /> Who gets a morning brief</div>
      <div className="grid gap-1.5 sm:grid-cols-2 lg:grid-cols-3">
        {rows.map(r => (
          <div key={r.id} className={`flex items-center gap-2 rounded-lg px-3 py-2 border ${r.enabled ? 'border-sky-300 bg-sky-50' : 'border-slate-200 bg-white'}`} data-testid={`brief-recipient-${r.id}`}>
            <button onClick={() => update(r, { enabled: !r.enabled })} disabled={busy === r.id} data-testid={`brief-recipient-toggle-${r.id}`}
              className={`w-9 h-5 p-0 rounded-full relative transition-colors shrink-0 ${r.enabled ? 'bg-sky-700' : 'bg-slate-300'}`} aria-label={`Brief for ${r.full_name}`}>
              <span className={`absolute left-0 top-0.5 w-4 h-4 rounded-full bg-white transition-transform ${r.enabled ? 'translate-x-[18px]' : 'translate-x-0.5'}`} />
            </button>
            <div className="min-w-0 flex-1">
              <div className="text-xs font-semibold text-slate-900 truncate">{r.full_name}</div>
              <div className="text-[10px] text-slate-500 truncate">{r.role.replace(/_/g, ' ')}{r.last_brief ? ` · last ${r.last_brief.date}${r.last_brief.google_ok === false ? ' (no mail)' : ''}` : ''}</div>
            </div>
            {r.enabled && (
              <select value={r.hour} onChange={e => update(r, { hour: parseInt(e.target.value) })} className="bg-white text-slate-900 text-[11px] rounded px-1 py-0.5 border border-slate-300" data-testid={`brief-recipient-hour-${r.id}`}>
                {[5, 6, 7, 8, 9, 10, 11].map(h => <option key={h} value={h}>{h} AM</option>)}
              </select>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
